import { render, staticRenderFns } from "./SearchPageSjN.vue?vue&type=template&id=728678be&scoped=true&"
import script from "./SearchPageSjN.vue?vue&type=script&lang=js&"
export * from "./SearchPageSjN.vue?vue&type=script&lang=js&"
import style0 from "./SearchPageSjN.vue?vue&type=style&index=0&id=728678be&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728678be",
  null
  
)

export default component.exports